import { render, staticRenderFns } from "./ManageModificator.vue?vue&type=template&id=852794c2"
import script from "./ManageModificator.vue?vue&type=script&lang=js"
export * from "./ManageModificator.vue?vue&type=script&lang=js"
import style0 from "./ManageModificator.vue?vue&type=style&index=0&id=852794c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports